/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  font-size: calc(14rem/14);
  line-height: calc(20rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host label {
  font-weight: 600;
}

.slotwrapper {
  display: none;
}`;
export { style };
//# sourceMappingURL=ValueDisplay.style.js.map